<template>
  <div class="tabs">
    <div
      v-for="item in activekeyList"
      :key="item.value"
      :class="{
        item: true,
        'is-active': activeKey === item.value,
        'is-hide': routeKey !== 'recommendActivekeyList' && item.routeKey && routeKey !== item.routeKey,
      }"
      @click="changeActiveKey(item)"
    >
      {{ item.label }}
      <!-- <span v-if="item.hotFlag?.title" class="hot-flag">{{ item.hotFlag.title }}</span> -->
      <span v-if="item.LabelText" class="hot-flag">{{ item.LabelText }}</span>
    </div>
    <div v-if="tipMessage" style="width: 100%; font-size: 16px">
      <a-tag v-if="tipMessage" color="red" style="font-size: 16px">
        {{ tipMessage }}
      </a-tag>
    </div>
    <!-- <a-button v-if="routeKey === 'flpPallet'" type="primary" ghost size="small" style="margin-left: 1em;margin-top: .2em" 
      @click="openPage('11')">
      福利品拉体验分操作手册
    </a-button> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    activekeyList: Array,
    //  activeKey: String,
    routeKey: String,
  },
  data() {
    return {
      activeKey: "",
      routeType: "",
      palletList: [],
      tag: { supply_movingFunction: "supply_chain_distribution", ali_movingFunction: "1688_distribution" },
      tipMessage: "",
    };
  },
  computed: {
    ...mapGetters({
      navList: "xfadmin/navList",
    }),
  },
  watch: {
    $route: {
      handler(params) {
        this.routeType = params.name;
        this.filterPalletList();
      },
      immediate: true,
    },

    navList() {
      if (this.routeType) {
        this.filterPalletList();
      }
    },
  },
  methods: {
    //筛选是否是1688货盘
    filterPalletList() {
      if (this.navList && this.navList.length > 0) {
        const nav = this.navList.filter((res) => {
          return res.Tag == this.tag[this.routeType];
        })[0];
        if (nav) {
          this.palletList = nav.PalletList;
          let activeItem = this.activekeyList.filter((res) => {
            return "ali_movingFunction" == res.routeKey && this.inPalletList(res);
          });
          this.activeKey = activeItem[0].value;
          this.tipMessage = activeItem[0].TipMessage;
          this.$emit("changeActiveKey", this.activeKey);
        }
      }

      //     this.activeKey = this.palletList[0].value;
    },
    //货盘是否配置显示
    inPalletList(item) {
      const inPallet = this.palletList.filter((res) => {
        if (res.Tag == item.apiTag) {
          item.LabelText = res.LabelText;
          item.Name = res.Name;
          item.TipMessage = res.TipMessage;
          return true;
        }
        return false;
      });
      return inPallet.length > 0;
    },
    //点击改变货盘
    changeActiveKey(item) {
      this.tipMessage = item.TipMessage;
      this.activeKey = item;
      this.$emit("changeActiveKey", item.value);
    },
    openPage(url) {
      url && open(url);
    },
  },
};
</script>
<style scoped lang="less">
@import "./index";
</style>
